<template>
	<div v-if="blocks && blocks.length" class="c-block-list">
		<template v-for="block in blocks">
			<Component
				:is="getBlockNameFromAlias(block.alias)"
				v-if="blockExists(block.alias)"
				:key="block.key"
				v-bind="block.content"
			/>

			<BlockListPlaceholder
				v-else-if="isDevelopment"
				:key="block.key"
				v-bind="block"
			/>
		</template>
	</div>
</template>

<script>
import BlockListPlaceholder from './blocks/BlockListPlaceholder.vue';

import {
	getBlockNameFromAlias,
	getBlocksBySolution,
} from '~/assets/js/block-lists';

const blocks = Object.assign(
	getBlocksBySolution('shared'),
	getBlocksBySolution('main')
);
const blockNames = Object.keys(blocks);

export default {
	name: 'MainBlockList',

	components: {
		BlockListPlaceholder,

		...blocks,
	},

	props: {
		blockList: {
			type: Array,

			default: () => [],
		},
	},

	data() {
		return {
			isDevelopment: process.env.NODE_ENV === 'development',
		};
	},

	computed: {
		blocks() {
			return (this.blockList ?? []).filter((block) => {
				if (!block || block?.content?.deactivated === true) {
					return false;
				}

				if (block?.alias && block?.content && block?.key) {
					return true;
				} else if (process.env.NODE_ENV === 'development') {
					console.warn(
						`[BlockList] ${block.alias} has missing or faulty data:`,
						block
					);
				}

				return false;
			});
		},
	},

	methods: {
		getBlockNameFromAlias,

		blockExists(alias) {
			return blockNames.includes(getBlockNameFromAlias(alias));
		},
	},
};
</script>

<style lang="postcss">
:where(.c-block-list) {
	@apply isolate grid grid-cols-1 gap-y-2xl/v;
}
:where(.c-block-list > .c-block-list-rte + .c-block-list-cta),
:where(.c-block-list > .c-block-list-cta + .c-block-list-cta) {
	margin-top: calc(
		var(--theme-verticalSpacing-xs-v, var(--theme-verticalSpacing-xs-v--sm)) -
			var(
				--theme-verticalSpacing-2xl-v,
				var(--theme-verticalSpacing-2xl-v--sm)
			)
	);
}

/* Make gray arias follow each other without a gap */
:where(.c-block-list > [class*='--block-gray'] + [class*='--block-gray']) {
	margin-top: calc(
		0px -
			var(
				--theme-verticalSpacing-2xl-v,
				var(--theme-verticalSpacing-2xl-v--sm)
			)
	);
}
</style>
